import styled from 'styled-components';

import { themeSize, themeZIndex } from '../../../theme/getters';
import { fadeInAndUpTransition } from '../../../theme/transitions';
import { fillAbsolute } from '../../../theme/mixins';
import { media } from '../../../theme/media';
import { ModalOverlay } from '../modalOverlay';

export const Overlay = styled(ModalOverlay)`
  z-index: ${themeZIndex('authOverlay')};
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ scrollable }) => (scrollable ? 'flex-start' : 'center')};
  ${fillAbsolute};
  overflow-y: ${props => (props.theme.isTransitioning ? 'visible' : 'auto')};
  -webkit-overflow-scrolling: touch;
  padding: 0 ${themeSize('contentPadding')}px;

  ${media.tablet`
     padding: 0;
  `}
`;

export const Content = styled.div`
  pointer-events: none;
  ${fadeInAndUpTransition};
`;
